/**
 * How a parsed row maps to {@link import('services/api/HrBot').default.checkIds} (`code` vs encrypted `id`).
 *
 * When the template **sendBy** is `code` but the PDF has no employee code and a DNI box is
 * filled, we route like “send by id” (OMM-594).
 */
export function getExtractionRoutingDescriptor(sendByField, parts) {
  const field = sendByField || 'code';
  const routedByDni = field === 'code' && !parts.code && !!parts.dni;
  const routeCheckFormat = field === 'id' || routedByDni ? 'id' : 'code';
  const routeCheckKey =
    routeCheckFormat === 'id' ? (field === 'id' ? parts.id : parts.dni) : parts.code;
  return { field, routedByDni, routeCheckFormat, routeCheckKey };
}

/**
 * Same predicate as SendDrawerContent hasExtractionFiles / internal send payload:
 * a row counts as “matched” only when we have a resolved recipient (user or DNI / employeeId path).
 */
export default function extractionFileMatchesForSend(file, sendBy) {
  if (!file || file.error) return false;
  if (sendBy === 'id') return !!file.employee?.id;
  if (file.routedByDni) return !!file.employee?.id;
  return !!(file.employee?.user?._id || file.employee?.user);
}
